import useOffersPageParams from './useOffersPageParams';

const useIsSelectedOffersPage = (): boolean => {
  const { page } = useOffersPageParams();
  return page === 'selected-offers';
};

export default useIsSelectedOffersPage;
